document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.menu-tabs .tab');
  const categories = document.querySelectorAll('.menu-category');

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      
      const category = this.getAttribute('data-category');
      categories.forEach(cat => {
        if (cat.id === category) {
          cat.classList.add('active');
        } else {
          cat.classList.remove('active');
        }
      });
    });
  });

  const addToCartButtons = document.querySelectorAll('.add-to-cart');
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function () {
      const productId = this.getAttribute('data-product-id');
      // Add to cart functionality here
    });
  });
});
